<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ErrorMessages from "@/components/global/ErrorMessages.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";

const store = useStore();
const websiteUrl = ref('');
const errors = computed(() => store.getters['appsumoWebsite/errors']);
const loading = computed(() => store.getters['appsumoWebsite/loading']);

const emit = defineEmits(['next']);

const handleAddWebsite = async () => {
  await store.dispatch('appsumoWebsite/validateWebsite', websiteUrl.value);

  if (!errors.value?.website) {
    websiteUrl.value = store.getters['appsumoWebsite/website'];
    emit('next');
  }
};

websiteUrl.value = store.getters['appsumoWebsite/website'];
</script>

<template>
  <div
    class="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-text-center tw-max-w-default-container tw-mx-auto tw-py-6 tw-min-h-[680px]"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-6 tw-gap-8 2xl:tw-w-2/5 tw-w-3/4">
      <div class="tw-flex tw-flex-col">
        <h1 class="tw-text-4xl tw-font-bold">
          Add Your Website
        </h1>
      </div>

      <div class="tw-flex tw-flex-col tw-text-lg">
        <p>Welcome to Hike!</p>
        <p>Before we dive in, we need a few key details from you.</p>
        <p>This will help our built-in SEO expert get started.</p>
      </div>

      <div class="tw-flex tw-flex-col tw-w-full tw-relative">
        <input
          v-model="websiteUrl"
          class="tw-rounded-lg tw-px-6 tw-py-3 tw-placeholder-slate-300"
          :class="[
            errors?.website ? 'tw-border-denali tw-border-2' : 'tw-border tw-border-grey-mid'
          ]"
          type="text"
          placeholder="Enter your website URL"
          @keyup.enter="handleAddWebsite"
        >
        <ErrorMessages
          v-if="errors?.website"
          class="tw-self-baseline"
          :errors="errors.website"
        />
      </div>

      <div class="tw-flex tw-w-full tw-justify-center sm:tw-justify-end">
        <div class="tw-flex tw-items-center tw-flex-col sm:tw-flex-row">
          <a
            href="/websites"
            class="tw-underline tw-text-blue tw-mr-0 sm:tw-mr-5"
          >
            Cancel
          </a>

          <DefaultButton
            :disabled="loading"
            :loading="loading"
            @click="handleAddWebsite"
          >
            <svg-vue
              width="22"
              height="19"
              class="tw-stroke-2 tw-mr-2"
              icon="icons/browser-with-plus-icon-in-corner"
            />
            Add Website
          </DefaultButton>
        </div>
      </div>
    </div>
  </div>
</template>
